import React, { Suspense } from 'react';
import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';

import PrivateRoute from './auth/PrivateRoute';
import GuestOnlyRoute from './auth/GuestOnlyRoute';
import Login from './auth/Login';

import Stock from './components/stock/Stock';
import Predictor from './components/predictor/Predictor';
import Prediction from './components/prediction/Prediction';
import Comment from './components/comment/Comment';
import StockPrices from './components/stockprices/Stockprices';

import StocktwitsBatchImportForm from './components/import/StocktwitsBatchImportForm';
import ImportLogs from "./components/import/ImportLogs";
import VersionFooter from './versionFooter';

import LazyFallback from './components/shared/LazyFallback';
import { Header } from './components/layout/Header';
import { Sidebar } from './components/layout/Sidebar';
import { CommandPalette } from './components/layout/CommandPalette';
import { SkipToContent } from './components/layout/SkipToContent';
import { useContext } from 'react';
import { AuthContext } from './auth/AuthContext';

const YahooFinanceDashboard = React.lazy(() => import('./components/yahoo/YahooFinanceDashboard'));

function App() {
  const { user } = useContext(AuthContext);

  const isAuthenticated = !!user?.email;

  return (
    <div className="relative flex min-h-screen">
      {isAuthenticated && <Sidebar />}
      <div className="flex flex-col flex-1 min-w-0">
        <SkipToContent />
        <Header />
        <main id="main-content" className="flex-1" tabIndex="-1">
          <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route
            path="/login"
            element={
              <GuestOnlyRoute>
                <Login />
              </GuestOnlyRoute>
            }
          />
          <Route
            path="/stock"
            element={
              <PrivateRoute>
                <Stock />
              </PrivateRoute>
            }
          />
          <Route
            path="/predictor"
            element={
              <PrivateRoute>
                <Predictor />
              </PrivateRoute>
            }
          />
          <Route
            path="/prediction"
            element={
              <PrivateRoute>
                <Prediction />
              </PrivateRoute>
            }
          />
          <Route
            path="/comment"
            element={
              <PrivateRoute>
                <Comment />
              </PrivateRoute>
            }
          />
          <Route
            path="/stockprices"
            element={
              <PrivateRoute>
                <StockPrices />
              </PrivateRoute>
            }
          />
          <Route
            path="/yahoo-finance"
            element={
              <Suspense fallback={<LazyFallback />}>
                <PrivateRoute>
                  <YahooFinanceDashboard />
                </PrivateRoute>
              </Suspense>
            }
          />
          <Route
            path="/import-stocktwits"
            element={
              <PrivateRoute>
                <StocktwitsBatchImportForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/import-logs"
            element={
              <PrivateRoute>
                <ImportLogs />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </main>

        {isAuthenticated && (
          <footer className="border-t py-4 text-center text-sm text-muted-foreground">
            <p>&copy; {new Date().getFullYear()} Stock Sights. Tous droits reserves.</p>
            <VersionFooter />
          </footer>
        )}
      </div>
      {isAuthenticated && <CommandPalette />}
    </div>
  );
}

export default App;
